import type { MasterPerson } from '../people/types.js';

/** Brief 6.6's meta: "Active since <date>", "Paused since <date>", "Left on <date>"; any other state, or no date known,
 * reads the server's statusWords (4.3). The date is the day in the viewer's time zone. */
export function stateLine(p: Pick<MasterPerson, 'status' | 'statusWords' | 'statusSince'>): string {
  if (!p.statusSince) return p.statusWords;
  const day = Number.isNaN(Date.parse(p.statusSince)) ? p.statusSince : new Date(p.statusSince).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  if (p.status === 'active') return `Active since ${day}`;
  if (p.status === 'suspended') return `Paused since ${day}`;
  if (p.status === 'departed') return `Left on ${day}`;
  return p.statusWords;
}
